module.exports = __webpack_public_path__ + "static/media/paso 1.0d22e163.svg";